import { render, staticRenderFns } from "./MobileDetails.vue?vue&type=template&id=f47d3918&"
import script from "./MobileDetails.vue?vue&type=script&lang=js&"
export * from "./MobileDetails.vue?vue&type=script&lang=js&"
import style0 from "./MobileDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports